import moment from 'moment';
import Wod from './Wod';
import User from './User';

/**
 * Comment with populated fields, but without embedded subcomments.
 * If the comment is subcomment it will have a value in `parent` field.
 */
class FlatComment {
  constructor({
    _id = null,
    parent = null,
    wod = null,
    createdAt = null,
    // eslint-disable-next-line
    author: {
      user: userAuthor = {},
      name: authorName = '',
    } = {},
    text = '',
  }) {
    this.id = _id;
    this.parent = parent;
    this.wod = wod ? new Wod(wod) : null;
    this.createdAt = createdAt ? moment(createdAt) : null;

    const author = userAuthor ? new User(userAuthor) : null;
    this.author = {
      user: author,
      name: authorName,
    };

    this.text = text;
  }
}

export default FlatComment;
